import React from 'react';
import { motion } from 'framer-motion';

const Career = () => (
  <motion.div className="page" initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
    <h2 className="page-title">Career</h2>
    <p className="page-content">Join our team and grow with us.</p>
  </motion.div>
);

export default Career;
